import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';
const countries = [
  {
    code: 'ARE',
    name: <FormattedMessage {...messages.abuDhabi} />,
    exchangeRate: 3.67,
    currencySymbol: 'DH',
    electricity: 0.163,
    carbonFactor: 471.6,
  },
  {
    code: 'AFG',
    name: <FormattedMessage {...messages.afghanistan} />,
    exchangeRate: 74.42,
    currencySymbol: '؋',
    electricity: 0.08,
    carbonFactor: 120.5,
  },
  {
    code: 'ALB',
    name: <FormattedMessage {...messages.albania} />,
    exchangeRate: 100.2,
    currencySymbol: 'L',
    electricity: 0.128,
    carbonFactor: 23.4,
  },
  {
    code: 'DZA',
    name: <FormattedMessage {...messages.algeria} />,
    exchangeRate: 136.28,
    currencySymbol: 'دج',
    electricity: 0.035,
    carbonFactor: 498.9,
  },
  {
    code: 'AND',
    name: <FormattedMessage {...messages.andorra} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.15,
    carbonFactor: 300,
  },
  {
    code: 'AGO',
    name: <FormattedMessage {...messages.angola} />,
    exchangeRate: 827.48,
    currencySymbol: 'Kz',
    electricity: 0.015,
    carbonFactor: 196,
  },
  {
    code: 'ATG',
    name: <FormattedMessage {...messages.antigua} />,
    exchangeRate: 2.7,
    currencySymbol: '$',
    electricity: 0.37,
    carbonFactor: 657.1,
  },
  {
    code: 'ARG',
    name: <FormattedMessage {...messages.argentina} />,
    exchangeRate: 350.02,
    currencySymbol: '$',
    electricity: 0.1,
    carbonFactor: 337.5,
  },

  {
    code: 'ABW',
    name: <FormattedMessage {...messages.aruba} />,
    exchangeRate: 1.8,
    currencySymbol: 'ƒ',
    electricity: 0.341,
    carbonFactor: 591.4,
  },
  {
    code: 'AUS',
    name: <FormattedMessage {...messages.australia} />,
    exchangeRate: 1.58,
    currencySymbol: '$',
    electricity: 0.27,
    carbonFactor: 503.2,
  },
  {
    code: 'AUT',
    name: <FormattedMessage {...messages.austria} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.19,
    carbonFactor: 157.5,
  },
  {
    code: 'AZE',
    name: <FormattedMessage {...messages.azerbaijan} />,
    exchangeRate: 1.7,
    currencySymbol: '₼',
    electricity: 0.065,
    carbonFactor: 532.9,
  },
  {
    code: 'BHS',
    name: <FormattedMessage {...messages.bahamas} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.35,
    carbonFactor: 698.1,
  },
  {
    code: 'BHR',
    name: <FormattedMessage {...messages.bahrain} />,
    exchangeRate: 0.38,
    currencySymbol: 'BHD',
    electricity: 0.077,
    carbonFactor: 489.8,
  },
  {
    code: 'BGD',
    name: <FormattedMessage {...messages.bangladesh} />,
    exchangeRate: 110.32,
    currencySymbol: 'BDT',
    electricity: 0.095,
    carbonFactor: 577,
  },
  {
    code: 'BRB',
    name: <FormattedMessage {...messages.barbados} />,
    exchangeRate: 2.02,
    currencySymbol: '$',
    electricity: 0.303,
    carbonFactor: 644.9,
  },

  {
    code: 'BEL',
    name: <FormattedMessage {...messages.belgium} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.21,
    carbonFactor: 165.4,
  },
  {
    code: 'BLZ',
    name: <FormattedMessage {...messages.belize} />,
    exchangeRate: 2.02,
    currencySymbol: 'BZ$',
    electricity: 0.173,
    carbonFactor: 484.4,
  },
  {
    code: 'BEN',
    name: <FormattedMessage {...messages.benin} />,
    exchangeRate: 627.97,
    currencySymbol: 'CFA',
    electricity: 0.18,
    carbonFactor: 666.7,
  },
  {
    code: 'BMU',
    name: <FormattedMessage {...messages.bermuda} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.265,
    carbonFactor: 350,
  },
  {
    code: 'BTN',
    name: <FormattedMessage {...messages.bhutan} />,
    exchangeRate: 83.29,
    currencySymbol: 'Nu.',
    electricity: 0.023,
    carbonFactor: 24.4,
  },
  {
    code: 'BOL',
    name: <FormattedMessage {...messages.bolivia} />,
    exchangeRate: 6.91,
    currencySymbol: 'Bs',
    electricity: 0.16,
    carbonFactor: 323.9,
  },
  {
    code: 'BIH',
    name: <FormattedMessage {...messages.bosnia} />,
    exchangeRate: 1.85,
    currencySymbol: 'KM',
    electricity: 0.085,
    carbonFactor: 517.2,
  },
  {
    code: 'BWA',
    name: <FormattedMessage {...messages.botswana} />,
    exchangeRate: 13.73,
    currencySymbol: 'P',
    electricity: 0.12,
    carbonFactor: 794.5,
  },
  {
    code: 'BRA',
    name: <FormattedMessage {...messages.brazil} />,
    exchangeRate: 5.01,
    currencySymbol: 'R$',
    electricity: 0.14,
    carbonFactor: 102,
  },
  {
    code: 'VGB',
    name: <FormattedMessage {...messages.britishVI} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.24,
    carbonFactor: 714.3,
  },
  {
    code: 'BRN',
    name: <FormattedMessage {...messages.brunei} />,
    exchangeRate: 1.37,
    currencySymbol: 'B$',
    electricity: 0.12,
    carbonFactor: 658.8,
  },
  {
    code: 'BGR',
    name: <FormattedMessage {...messages.bulgaria} />,
    exchangeRate: 1.85,
    currencySymbol: 'лв',
    electricity: 0.275,
    carbonFactor: 399.6,
  },

  {
    code: 'BDI',
    name: <FormattedMessage {...messages.burundi} />,
    exchangeRate: 2846,
    currencySymbol: 'FBu',
    electricity: 0.33,
    carbonFactor: 250,
  },
  {
    code: 'KHM',
    name: <FormattedMessage {...messages.cambodia} />,
    exchangeRate: 4142,
    currencySymbol: '៛',
    electricity: 0.16,
    carbonFactor: 400.5,
  },
  {
    code: 'CMR',
    name: <FormattedMessage {...messages.cameroon} />,
    exchangeRate: 621.97,
    currencySymbol: 'XAF',
    electricity: 0.172,
    carbonFactor: 278.3,
  },
  {
    code: 'CAN',
    name: <FormattedMessage {...messages.canada} />,
    exchangeRate: 1.39,
    currencySymbol: '$',
    electricity: 0.104,
    carbonFactor: 127.8,
  },
  {
    code: 'CPV',
    name: <FormattedMessage {...messages.capeVerde} />,
    exchangeRate: 104.58,
    currencySymbol: '$',
    electricity: 0.195,
    carbonFactor: 600,
  },
  {
    code: 'CYM',
    name: <FormattedMessage {...messages.caymanIslands} />,
    exchangeRate: 0.83,
    currencySymbol: 'CI$',
    electricity: 0.376,
    carbonFactor: 684.9,
  },
  {
    code: 'CAF',
    name: <FormattedMessage {...messages.centralAfricanRepublic} />,
    exchangeRate: 621.97,
    currencySymbol: 'FCFA',
    electricity: 0.1,
    carbonFactor: 475,
  },
  {
    code: 'TCD',
    name: <FormattedMessage {...messages.chad} />,
    exchangeRate: 621.97,
    currencySymbol: 'FCFA',
    electricity: 0.37,
    carbonFactor: 677.4,
  },
  {
    code: 'CHL',
    name: <FormattedMessage {...messages.chile} />,
    exchangeRate: 909.09,
    currencySymbol: 'CLP',
    electricity: 0.125,
    carbonFactor: 333.2,
  },
  {
    code: 'CHN',
    name: <FormattedMessage {...messages.china} />,
    exchangeRate: 7.32,
    currencySymbol: '¥',
    electricity: 0.095,
    carbonFactor: 530.8,
  },
  {
    code: 'COL',
    name: <FormattedMessage {...messages.colombia} />,
    exchangeRate: 4133.99,
    currencySymbol: '$',
    electricity: 0.174,
    carbonFactor: 169,
  },
  {
    code: 'COM',
    name: <FormattedMessage {...messages.comoros} />,
    exchangeRate: 465.87,
    currencySymbol: 'KMF',
    electricity: 0.7,
    carbonFactor: 714.3,
  },
  {
    code: 'COG',
    name: <FormattedMessage {...messages.congo} />,
    exchangeRate: 2597.5,
    currencySymbol: 'CDF',
    electricity: 0.105,
    carbonFactor: 395.5,
  },
  {
    code: 'COD',
    name: <FormattedMessage {...messages.congoDemRepublic} />,
    exchangeRate: 2597.5,
    currencySymbol: 'CDF',
    electricity: 0.085,
    carbonFactor: 395.5,
  },
  {
    code: 'CRI',
    name: <FormattedMessage {...messages.costaRica} />,
    exchangeRate: 531.07,
    currencySymbol: '₡',
    electricity: 0.211,
    carbonFactor: 37.2,
  },
  {
    code: 'HRV',
    name: <FormattedMessage {...messages.croatia} />,
    exchangeRate: 7.04,
    currencySymbol: '€',
    electricity: 0.17,
    carbonFactor: 246.5,
  },
  {
    code: 'CYP',
    name: <FormattedMessage {...messages.cyprus} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.275,
    carbonFactor: 589.4,
  },
  {
    code: 'CZE',
    name: <FormattedMessage {...messages.czechRepublic} />,
    exchangeRate: 23.32,
    currencySymbol: 'Kč',
    electricity: 0.21,
    carbonFactor: 444,
  },
  {
    code: 'DNK',
    name: <FormattedMessage {...messages.denmark} />,
    exchangeRate: 7.07,
    currencySymbol: 'kr',
    electricity: 0.25,
    carbonFactor: 180.7,
  },
  {
    code: 'DMA',
    name: <FormattedMessage {...messages.dominica} />,
    exchangeRate: 2.7,
    currencySymbol: '$',
    electricity: 0.39,
    carbonFactor: 529.4,
  },
  {
    code: 'DOM',
    name: <FormattedMessage {...messages.dominicanRepublic} />,
    exchangeRate: 56.9,
    currencySymbol: 'RD$',
    electricity: 0.178,
    carbonFactor: 550.9,
  },
  {
    code: 'ECU',
    name: <FormattedMessage {...messages.ecuador} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.085,
    carbonFactor: 188.7,
  },
  {
    code: 'EGY',
    name: <FormattedMessage {...messages.egypt} />,
    exchangeRate: 30.86,
    currencySymbol: '£',
    electricity: 0.041,
    carbonFactor: 485.4,
  },
  {
    code: 'SLV',
    name: <FormattedMessage {...messages.elSalvador} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.21,
    carbonFactor: 194.2,
  },
  {
    code: 'GNQ',
    name: <FormattedMessage {...messages.equatorialGuinea} />,
    exchangeRate: 621.97,
    currencySymbol: 'XAF',
    electricity: 0.1,
    carbonFactor: 493,
  },
  {
    code: 'ERI',
    name: <FormattedMessage {...messages.eritrea} />,
    exchangeRate: 15,
    currencySymbol: 'ERN',
    electricity: 0.17,
    carbonFactor: 688.9,
  },
  {
    code: 'EST',
    name: <FormattedMessage {...messages.estonia} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.19,
    carbonFactor: 464,
  },
  {
    code: 'ETH',
    name: <FormattedMessage {...messages.ethiopia} />,
    exchangeRate: 55.9,
    currencySymbol: 'Br',
    electricity: 0.022,
    carbonFactor: 25.2,
  },
  {
    code: 'FRO',
    name: <FormattedMessage {...messages.faroeIslands} />,
    exchangeRate: 7.03,
    currencySymbol: 'kr',
    electricity: 0.21,
    carbonFactor: 428.6,
  },
  {
    code: 'FJI',
    name: <FormattedMessage {...messages.fiji} />,
    exchangeRate: 2.28,
    currencySymbol: '$',
    electricity: 0.36,
    carbonFactor: 289.5,
  },
  {
    code: 'FIN',
    name: <FormattedMessage {...messages.finland} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.111,
    carbonFactor: 131,
  },
  {
    code: 'FRA',
    name: <FormattedMessage {...messages.france} />,
    exchangeRate: 0.92,
    currencySymbol: '€',
    electricity: 0.185,
    carbonFactor: 84.8,
  },
  {
    code: 'GUF',
    name: <FormattedMessage {...messages.frenchGuiana} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.135,
    carbonFactor: 642.3,
  },
  {
    code: 'PYF',
    name: <FormattedMessage {...messages.frenchPolynesia} />,
    exchangeRate: 113.3,
    currencySymbol: '₣',
    electricity: 0.45,
    carbonFactor: 471.4,
  },
  {
    code: 'GAB',
    name: <FormattedMessage {...messages.gabon} />,
    exchangeRate: 621.97,
    currencySymbol: 'XAF',
    electricity: 0.2,
    carbonFactor: 397.4,
  },
  {
    code: 'GMB',
    name: <FormattedMessage {...messages.gambia} />,
    exchangeRate: 65.5,
    currencySymbol: 'D',
    electricity: 0.23,
    carbonFactor: 700,
  },
  {
    code: 'GEO',
    name: <FormattedMessage {...messages.georgia} />,
    exchangeRate: 2.69,
    currencySymbol: 'ლ',
    electricity: 0.115,
    carbonFactor: 134.8,
  },
  {
    code: 'DEU',
    name: <FormattedMessage {...messages.germany} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.29,
    carbonFactor: 385.5,
  },
  {
    code: 'GHA',
    name: <FormattedMessage {...messages.ghana} />,
    exchangeRate: 11.9,
    currencySymbol: '¢',
    electricity: 0.111,
    carbonFactor: 361.2,
  },
  {
    code: 'GIB',
    name: <FormattedMessage {...messages.gibraltar} />,
    exchangeRate: 0.79,
    currencySymbol: 'GIP',
    electricity: 0.145,
    carbonFactor: 300,
  },
  {
    code: 'GRC',
    name: <FormattedMessage {...messages.greece} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.32,
    carbonFactor: 343.8,
  },
  {
    code: 'GRL',
    name: <FormattedMessage {...messages.greenland} />,
    exchangeRate: 7.04,
    currencySymbol: 'Kr.',
    electricity: 0.27,
    carbonFactor: 133.3,
  },
  {
    code: 'GRD',
    name: <FormattedMessage {...messages.grenada} />,
    exchangeRate: 2.69,
    currencySymbol: '$',
    electricity: 0.63,
    carbonFactor: 714.3,
  },
  {
    code: 'GLP',
    name: <FormattedMessage {...messages.guadeloupe} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.18,
    carbonFactor: 529.4,
  },
  {
    code: 'GUM',
    name: <FormattedMessage {...messages.guam} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.24,
    carbonFactor: 670.3,
  },
  {
    code: 'GTM',
    name: <FormattedMessage {...messages.guatemala} />,
    exchangeRate: 7.83,
    currencySymbol: 'Q',
    electricity: 0.18,
    carbonFactor: 320.6,
  },
  {
    code: 'GNB',
    name: <FormattedMessage {...messages.guineaBissau} />,
    exchangeRate: 619.22,
    currencySymbol: 'CFA',
    electricity: 0.5,
    carbonFactor: 750,
  },

  {
    code: 'GUY',
    name: <FormattedMessage {...messages.guyana} />,
    exchangeRate: 208.63,
    currencySymbol: '$',
    electricity: 0.35,
    carbonFactor: 642.3,
  },
  {
    code: 'HTI',
    name: <FormattedMessage {...messages.haiti} />,
    exchangeRate: 132.68,
    currencySymbol: 'G',
    electricity: 0.35,
    carbonFactor: 606.1,
  },
  {
    code: 'HND',
    name: <FormattedMessage {...messages.honduras} />,
    exchangeRate: 24.67,
    currencySymbol: 'L',
    electricity: 0.25,
    carbonFactor: 375.1,
  },
  {
    code: 'HKG',
    name: <FormattedMessage {...messages.hongKong} />,
    exchangeRate: 7.82,
    currencySymbol: '$',
    electricity: 0.197,
    carbonFactor: 684,
  },
  {
    code: 'HUN',
    name: <FormattedMessage {...messages.hungary} />,
    exchangeRate: 360.57,
    currencySymbol: 'Ft',
    electricity: 0.185,
    carbonFactor: 223,
  },
  {
    code: 'ISL',
    name: <FormattedMessage {...messages.iceland} />,
    exchangeRate: 138.64,
    currencySymbol: 'kr',
    electricity: 0.102,
    carbonFactor: 28.6,
  },
  {
    code: 'IND',
    name: <FormattedMessage {...messages.india} />,
    exchangeRate: 83.26,
    currencySymbol: '₹',
    electricity: 0.125,
    carbonFactor: 632.4,
  },
  {
    code: 'IRN',
    name: <FormattedMessage {...messages.iran} />,
    exchangeRate: 42263,
    currencySymbol: '﷼',
    electricity: 0.03,
    carbonFactor: 493.6,
  },
  {
    code: 'IRQ',
    name: <FormattedMessage {...messages.iraq} />,
    exchangeRate: 1308.42,
    currencySymbol: 'IQD',
    electricity: 0.048,
    carbonFactor: 498.9,
  },
  {
    code: 'IDN',
    name: <FormattedMessage {...messages.indonesia} />,
    exchangeRate: 11181,
    currencySymbol: 'Rp',
    electricity: 0.072,
    carbonFactor: 623.3,
  },
  {
    code: 'IRL',
    name: <FormattedMessage {...messages.ireland} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.255,
    carbonFactor: 345.3,
  },
  {
    code: 'ISR',
    name: <FormattedMessage {...messages.israel} />,
    exchangeRate: 4.04,
    currencySymbol: '₪',
    electricity: 0.165,
    carbonFactor: 548,
  },

  {
    code: 'ITA',
    name: <FormattedMessage {...messages.italy} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.285,
    carbonFactor: 371.7,
  },
  {
    code: 'CIV',
    name: <FormattedMessage {...messages.ivoryCoast} />,
    exchangeRate: 619.22,
    currencySymbol: 'CFA',
    electricity: 0.198,
    carbonFactor: 411,
  },
  {
    code: 'JAM',
    name: <FormattedMessage {...messages.jamaica} />,
    exchangeRate: 154.37,
    currencySymbol: 'J$',
    electricity: 0.28,
    carbonFactor: 519.5,
  },
  {
    code: 'JPN',
    name: <FormattedMessage {...messages.japan} />,
    exchangeRate: 149.77,
    currencySymbol: '¥',
    electricity: 0.228,
    carbonFactor: 482.9,
  },
  {
    code: 'JOR',
    name: <FormattedMessage {...messages.jordan} />,
    exchangeRate: 0.71,
    currencySymbol: 'JOD',
    electricity: 0.132,
    carbonFactor: 399.9,
  },
  {
    code: 'KAZ',
    name: <FormattedMessage {...messages.kazakhstan} />,
    exchangeRate: 471.4,
    currencySymbol: 'лв',
    electricity: 0.062,
    carbonFactor: 635.6,
  },
  {
    code: 'KEN',
    name: <FormattedMessage {...messages.kenya} />,
    exchangeRate: 150.6,
    currencySymbol: 'KES',
    electricity: 0.15,
    carbonFactor: 99.9,
  },
  {
    code: 'KIR',
    name: <FormattedMessage {...messages.kiribati} />,
    exchangeRate: 1.41,
    currencySymbol: '$',
    electricity: 0.37,
    carbonFactor: 666.7,
  },
  {
    code: 'KOR',
    name: <FormattedMessage {...messages.korea} />,
    exchangeRate: 1347.89,
    currencySymbol: '₩',
    electricity: 0.12,
    carbonFactor: 436,
  },
  {
    code: 'KWT',
    name: <FormattedMessage {...messages.kuwait} />,
    exchangeRate: 0.31,
    currencySymbol: 'KWD',
    electricity: 0.051,
    carbonFactor: 489.6,
  },
  {
    code: 'KGZ',
    name: <FormattedMessage {...messages.kyrgyzstan} />,
    exchangeRate: 89.32,
    currencySymbol: 'Лв',
    electricity: 0.034,
    carbonFactor: 104.4,
  },
  {
    code: 'LAO',
    name: <FormattedMessage {...messages.laos} />,
    exchangeRate: 20740,
    currencySymbol: '₭',
    electricity: 0.132,
    carbonFactor: 242.2,
  },
  {
    code: 'LVA',
    name: <FormattedMessage {...messages.latvia} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.176,
    carbonFactor: 181.8,
  },
  {
    code: 'LBN',
    name: <FormattedMessage {...messages.lebanon} />,
    exchangeRate: 15032.5,
    currencySymbol: '£',
    electricity: 0.174,
    carbonFactor: 594.8,
  },
  {
    code: 'LSO',
    name: <FormattedMessage {...messages.lesotho} />,
    exchangeRate: 18.84,
    currencySymbol: 'L',
    electricity: 0.021,
    carbonFactor: 20,
  },
  {
    code: 'LBR',
    name: <FormattedMessage {...messages.liberia} />,
    exchangeRate: 187.49,
    currencySymbol: 'L$',
    electricity: 0.43,
    carbonFactor: 304.3,
  },
  {
    code: 'LBY',
    name: <FormattedMessage {...messages.libyanArabJamahiriya} />,
    exchangeRate: 4.89,
    currencySymbol: 'LD',
    electricity: 0.01,
    carbonFactor: 550,
  },
  {
    code: 'LIE',
    name: <FormattedMessage {...messages.liechtenstein} />,
    exchangeRate: 0.9,
    currencySymbol: 'SFr',
    electricity: 0.153,
    carbonFactor: 151,
  },
  {
    code: 'LTU',
    name: <FormattedMessage {...messages.lithuania} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.208,
    carbonFactor: 194.2,
  },
  {
    code: 'LUX',
    name: <FormattedMessage {...messages.luxembourg} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.148,
    carbonFactor: 168.1,
  },
  {
    code: 'MAC',
    name: <FormattedMessage {...messages.macau} />,
    exchangeRate: 8.05,
    currencySymbol: 'MOP$',
    electricity: 0.163,
    carbonFactor: 786,
  },
  {
    code: 'MKD',
    name: <FormattedMessage {...messages.macedonia} />,
    exchangeRate: 58.09,
    currencySymbol: 'Ден',
    electricity: 0.193,
    carbonFactor: 529,
  },
  {
    code: 'MDG',
    name: <FormattedMessage {...messages.madagascar} />,
    exchangeRate: 4530,
    currencySymbol: 'MT',
    electricity: 0.105,
    carbonFactor: 483.3,
  },
  {
    code: 'MWI',
    name: <FormattedMessage {...messages.malawi} />,
    exchangeRate: 1142.5,
    currencySymbol: 'MK',
    electricity: 0.135,
    carbonFactor: 133.8,
  },
  {
    code: 'MYS',
    name: <FormattedMessage {...messages.malaysia} />,
    exchangeRate: 4.76,
    currencySymbol: 'RM',
    electricity: 0.115,
    carbonFactor: 543.7,
  },
  {
    code: 'MDV',
    name: <FormattedMessage {...messages.maldives} />,
    exchangeRate: 15.38,
    currencySymbol: 'Rf',
    electricity: 0.4,
    carbonFactor: 651.5,
  },
  {
    code: 'MLI',
    name: <FormattedMessage {...messages.mali} />,
    exchangeRate: 619.22,
    currencySymbol: 'CFA',
    electricity: 0.153,
    carbonFactor: 466.1,
  },
  {
    code: 'MLT',
    name: <FormattedMessage {...messages.malta} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.155,
    carbonFactor: 442.5,
  },
  {
    code: 'MTQ',
    name: <FormattedMessage {...messages.martinique} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.95,
    carbonFactor: 700,
  },
  {
    code: 'MRT',
    name: <FormattedMessage {...messages.mauritania} />,
    exchangeRate: 39.25,
    currencySymbol: 'MRU',
    electricity: 0.12,
    carbonFactor: 526.6,
  },
  {
    code: 'MUS',
    name: <FormattedMessage {...messages.mauritius} />,
    exchangeRate: 44.25,
    currencySymbol: 'Rs',
    electricity: 0.14,
    carbonFactor: 611.1,
  },
  {
    code: 'MYT',
    name: <FormattedMessage {...messages.mayotte} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.19,
    carbonFactor: 550,
  },
  {
    code: 'MEX',
    name: <FormattedMessage {...messages.mexico} />,
    exchangeRate: 18.04,
    currencySymbol: '$',
    electricity: 0.2,
    carbonFactor: 421.4,
  },
  {
    code: 'MDA',
    name: <FormattedMessage {...messages.moldova} />,
    exchangeRate: 18.11,
    currencySymbol: 'MDL',
    electricity: 0.095,
    carbonFactor: 678.4,
  },
  {
    code: 'MCO',
    name: <FormattedMessage {...messages.monaco} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.15,
    carbonFactor: 150,
  },
  {
    code: 'MNG',
    name: <FormattedMessage {...messages.mongolia} />,
    exchangeRate: 3460,
    currencySymbol: '₮',
    electricity: 0.14,
    carbonFactor: 749.7,
  },
  {
    code: 'MNE',
    name: <FormattedMessage {...messages.montenegro} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.097,
    carbonFactor: 399.4,
  },
  {
    code: 'MSR',
    name: <FormattedMessage {...messages.montserrat} />,
    exchangeRate: 2.7,
    currencySymbol: '$',
    electricity: 0.6,
    carbonFactor: 1000,
  },
  {
    code: 'MAR',
    name: <FormattedMessage {...messages.morocco} />,
    exchangeRate: 10.27,
    currencySymbol: 'MAD',
    electricity: 0.11,
    carbonFactor: 610.4,
  },
  {
    code: 'MOZ',
    name: <FormattedMessage {...messages.mozambique} />,
    exchangeRate: 63.89,
    currencySymbol: 'MT',
    electricity: 0.082,
    carbonFactor: 126.6,
  },
  {
    code: 'MMR',
    name: <FormattedMessage {...messages.myanmarBurma} />,
    exchangeRate: 2099.34,
    currencySymbol: 'K',
    electricity: 0.08,
    carbonFactor: 344,
  },
  {
    code: 'NAM',
    name: <FormattedMessage {...messages.namibia} />,
    exchangeRate: 18.71,
    currencySymbol: '$',
    electricity: 0.15,
    carbonFactor: 63.7,
  },
  {
    code: 'MPL',
    name: <FormattedMessage {...messages.nepal} />,
    exchangeRate: 133.14,
    currencySymbol: '₨',
    electricity: 0.073,
    carbonFactor: 24.5,
  },
  {
    code: 'NLD',
    name: <FormattedMessage {...messages.netherlands} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.195,
    carbonFactor: 355,
  },
  {
    code: 'ANT',
    name: <FormattedMessage {...messages.netherlandsAntilles} />,
    exchangeRate: 1.8,
    currencySymbol: 'f',
    electricity: 0.35,
    carbonFactor: 500,
  },
  {
    code: 'NCL',
    name: <FormattedMessage {...messages.newCaledonia} />,
    exchangeRate: 112.92,
    currencySymbol: '₣',
    electricity: 0.35,
    carbonFactor: 610.1,
  },
  {
    code: 'NIC',
    name: <FormattedMessage {...messages.nicaragua} />,
    exchangeRate: 36.59,
    currencySymbol: 'C$',
    electricity: 0.24,
    carbonFactor: 354.2,
  },
  {
    code: 'NER',
    name: <FormattedMessage {...messages.niger} />,
    exchangeRate: 786.5,
    currencySymbol: 'FCFA',
    electricity: 0.145,
    carbonFactor: 622.2,
  },
  {
    code: 'NZL',
    name: <FormattedMessage {...messages.newZealand} />,
    exchangeRate: 1.72,
    currencySymbol: '$',
    electricity: 0.23,
    carbonFactor: 97.7,
  },
  {
    code: 'NGA',
    name: <FormattedMessage {...messages.nigeria} />,
    exchangeRate: 786.5,
    currencySymbol: '₦',
    electricity: 0.058,
    carbonFactor: 368.2,
  },
  {
    code: 'NOR',
    name: <FormattedMessage {...messages.norway} />,
    exchangeRate: 11.16,
    currencySymbol: 'kr',
    electricity: 0.178,
    carbonFactor: 28.8,
  },
  {
    code: 'OMN',
    name: <FormattedMessage {...messages.oman} />,
    exchangeRate: 0.38,
    currencySymbol: '﷼',
    electricity: 0.153,
    carbonFactor: 488.3,
  },
  {
    code: 'PAK',
    name: <FormattedMessage {...messages.pakistan} />,
    exchangeRate: 281.06,
    currencySymbol: '₨',
    electricity: 0.165,
    carbonFactor: 344.2,
  },
  {
    code: 'PAN',
    name: <FormattedMessage {...messages.panama} />,
    exchangeRate: 1,
    currencySymbol: 'B/.',
    electricity: 0.19,
    carbonFactor: 192.1,
  },
  {
    code: 'PNG',
    name: <FormattedMessage {...messages.papuaNewGuinea} />,
    exchangeRate: 3.76,
    currencySymbol: 'K',
    electricity: 0.18,
    carbonFactor: 526.7,
  },
  {
    code: 'PRY',
    name: <FormattedMessage {...messages.paraguay} />,
    exchangeRate: 7469,
    currencySymbol: 'Gs',
    electricity: 0.045,
    carbonFactor: 25.5,
  },
  {
    code: 'PER',
    name: <FormattedMessage {...messages.peru} />,
    exchangeRate: 3.82,
    currencySymbol: 'S/.',
    electricity: 0.17,
    carbonFactor: 256.5,
  },
  {
    code: 'PHL',
    name: <FormattedMessage {...messages.philippines} />,
    exchangeRate: 56.83,
    currencySymbol: 'Php',
    electricity: 0.148,
    carbonFactor: 582,
  },
  {
    code: 'POL',
    name: <FormattedMessage {...messages.poland} />,
    exchangeRate: 4.21,
    currencySymbol: 'zł',
    electricity: 0.19,
    carbonFactor: 634.6,
  },
  {
    code: 'PRT',
    name: <FormattedMessage {...messages.portugal} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.16,
    carbonFactor: 234,
  },
  {
    code: 'PRI',
    name: <FormattedMessage {...messages.puertoRico} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.26,
    carbonFactor: 681.5,
  },
  {
    code: 'QAT',
    name: <FormattedMessage {...messages.qatar} />,
    exchangeRate: 3.64,
    currencySymbol: '﷼',
    electricity: 0.038,
    carbonFactor: 489.8,
  },
  {
    code: 'DJI',
    name: <FormattedMessage {...messages.republicOfDjibouti} />,
    exchangeRate: 177.92,
    currencySymbol: 'Fdj',
    electricity: 0.3,
    carbonFactor: 667,
  },
  {
    code: 'RDA',
    name: <FormattedMessage {...messages.republicOfMoldova} />,
    exchangeRate: 18.12,
    currencySymbol: 'L',
    electricity: 0.068,
    carbonFactor: 678,
  },
  {
    code: 'REU',
    name: <FormattedMessage {...messages.reunion} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.8,
    carbonFactor: 611,
  },
  {
    code: 'ROU',
    name: <FormattedMessage {...messages.romania} />,
    exchangeRate: 4.7,
    currencySymbol: 'lei',
    electricity: 0.275,
    carbonFactor: 264.1,
  },
  {
    code: 'RWA',
    name: <FormattedMessage {...messages.rwanda} />,
    exchangeRate: 1241.53,
    currencySymbol: 'FRw',
    electricity: 0.082,
    carbonFactor: 294.1,
  },
  {
    code: 'KNA',
    name: <FormattedMessage {...messages.saintKittsNevis} />,
    exchangeRate: 2.7,
    currencySymbol: '$',
    electricity: 0.34,
    carbonFactor: 681.8,
  },
  {
    code: 'VCT',
    name: <FormattedMessage {...messages.saintVincentGrenadines} />,
    exchangeRate: 2.7,
    currencySymbol: 'XCD',
    electricity: 0.28,
    carbonFactor: 500,
  },
  {
    code: 'WSM',
    name: <FormattedMessage {...messages.samoa} />,
    exchangeRate: 2.8,
    currencySymbol: 'WS$',
    electricity: 0.34,
    carbonFactor: 470.6,
  },
  {
    code: 'SMR',
    name: <FormattedMessage {...messages.sanMarino} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.28,
    carbonFactor: 400,
  },
  {
    code: 'STP',
    name: <FormattedMessage {...messages.saoTomePrincipe} />,
    exchangeRate: 23247,
    currencySymbol: 'Dd',
    electricity: 0.21,
    carbonFactor: 600,
  },
  {
    code: 'SAU',
    name: <FormattedMessage {...messages.saudiArabia} />,
    exchangeRate: 3.75,
    currencySymbol: '﷼',
    electricity: 0.07,
    carbonFactor: 571.3,
  },
  {
    code: 'SEN',
    name: <FormattedMessage {...messages.senegal} />,
    exchangeRate: 621.12,
    currencySymbol: 'CFA',
    electricity: 0.25,
    carbonFactor: 523.1,
  },
  {
    code: 'SRB',
    name: <FormattedMessage {...messages.serbia} />,
    exchangeRate: 110.96,
    currencySymbol: 'Дин.',
    electricity: 0.115,
    carbonFactor: 569.4,
  },
  {
    code: 'SYC',
    name: <FormattedMessage {...messages.seychelles} />,
    exchangeRate: 14.4,
    currencySymbol: '₨',
    electricity: 0.3,
    carbonFactor: 615.4,
  },
  {
    code: 'SLE',
    name: <FormattedMessage {...messages.sierraLeone} />,
    exchangeRate: 19679,
    currencySymbol: 'SLL',
    electricity: 0.18,
    carbonFactor: 47.6,
  },
  {
    code: 'SLB',
    name: <FormattedMessage {...messages.solomonIsland} />,
    exchangeRate: 8.43,
    currencySymbol: 'SI$',
    electricity: 0.6,
    carbonFactor: 727,
  },
  {
    code: 'SOM',
    name: <FormattedMessage {...messages.somalia} />,
    exchangeRate: 568.02,
    currencySymbol: 'S',
    electricity: 0.65,
    carbonFactor: 634.1,
  },
  {
    code: 'SGP',
    name: <FormattedMessage {...messages.singapore} />,
    exchangeRate: 1.37,
    currencySymbol: '$',
    electricity: 0.32,
    carbonFactor: 488.8,
  },
  {
    code: 'SVK',
    name: <FormattedMessage {...messages.slovakia} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.255,
    carbonFactor: 140.7,
  },
  {
    code: 'SVN',
    name: <FormattedMessage {...messages.slovenia} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.182,
    carbonFactor: 237.4,
  },
  {
    code: 'ZAF',
    name: <FormattedMessage {...messages.southAfrica} />,
    exchangeRate: 18.68,
    currencySymbol: 'R',
    electricity: 0.075,
    carbonFactor: 709,
  },
  {
    code: 'ESP',
    name: <FormattedMessage {...messages.spain} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.225,
    carbonFactor: 217.4,
  },
  {
    code: 'LKA',
    name: <FormattedMessage {...messages.sriLanka} />,
    exchangeRate: 327.91,
    currencySymbol: '₨',
    electricity: 0.102,
    carbonFactor: 463,
  },
  {
    code: 'LCA',
    name: <FormattedMessage {...messages.stLucia} />,
    exchangeRate: 2.7,
    currencySymbol: 'XCD',
    electricity: 0.33,
    carbonFactor: 686,
  },
  {
    code: 'SDN',
    name: <FormattedMessage {...messages.sudan} />,
    exchangeRate: 600.5,
    currencySymbol: 'SDG',
    electricity: 0.044,
    carbonFactor: 264,
  },
  {
    code: 'SWE',
    name: <FormattedMessage {...messages.sweden} />,
    exchangeRate: 11.17,
    currencySymbol: 'kr',
    electricity: 0.175,
    carbonFactor: 45.1,
  },
  {
    code: 'CHE',
    name: <FormattedMessage {...messages.switzerland} />,
    exchangeRate: 0.91,
    currencySymbol: 'SFr',
    electricity: 0.266,
    carbonFactor: 45.6,
  },
  {
    code: 'SYR',
    name: <FormattedMessage {...messages.syriaArabRepublic} />,
    exchangeRate: 13002,
    currencySymbol: 'LS',
    electricity: 0.017,
    carbonFactor: 541,
  },
  {
    code: 'TWN',
    name: <FormattedMessage {...messages.taiwan} />,
    exchangeRate: 32.46,
    currencySymbol: 'NT$',
    electricity: 0.14,
    carbonFactor: 561,
  },
  {
    code: 'TJK',
    name: <FormattedMessage {...messages.tajikistan} />,
    exchangeRate: 10.95,
    currencySymbol: 'SM',
    electricity: 0.25,
    carbonFactor: 83.6,
  },
  {
    code: 'TZA',
    name: <FormattedMessage {...messages.tanzania} />,
    exchangeRate: 2500,
    currencySymbol: 'TSh',
    electricity: 0.101,
    carbonFactor: 366.7,
  },
  {
    code: 'THA',
    name: <FormattedMessage {...messages.thailand} />,
    exchangeRate: 36.11,
    currencySymbol: '฿',
    electricity: 0.153,
    carbonFactor: 502.3,
  },
  {
    code: 'TGO',
    name: <FormattedMessage {...messages.togo} />,
    exchangeRate: 619.86,
    currencySymbol: 'CFA',
    electricity: 0.172,
    carbonFactor: 460.3,
  },
  {
    code: 'TON',
    name: <FormattedMessage {...messages.tonga} />,
    exchangeRate: 2.4,
    currencySymbol: 'T$',
    electricity: 0.39,
    carbonFactor: 625,
  },
  {
    code: 'TTO',
    name: <FormattedMessage {...messages.trinidad} />,
    exchangeRate: 6.78,
    currencySymbol: 'TT$',
    electricity: 0.053,
    carbonFactor: 491,
  },
  {
    code: 'TUN',
    name: <FormattedMessage {...messages.tunisia} />,
    exchangeRate: 3.18,
    currencySymbol: 'DT',
    electricity: 0.111,
    carbonFactor: 469.4,
  },
  {
    code: 'TUR',
    name: <FormattedMessage {...messages.turkey} />,
    exchangeRate: 28.3,
    currencySymbol: '₺',
    electricity: 0.141,
    carbonFactor: 413.6,
  },
  {
    code: 'TKM',
    name: <FormattedMessage {...messages.turkmenistan} />,
    exchangeRate: 3.49,
    currencySymbol: 'T',
    electricity: 0.04,
    carbonFactor: 490.2,
  },
  {
    code: 'TCA',
    name: <FormattedMessage {...messages.turksCaicosIslands} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.29,
    carbonFactor: 703.7,
  },
  {
    code: 'UGA',
    name: <FormattedMessage {...messages.uganda} />,
    exchangeRate: 3783.52,
    currencySymbol: 'USh',
    electricity: 0.125,
    carbonFactor: 52.3,
  },
  {
    code: 'UKR',
    name: <FormattedMessage {...messages.ukraine} />,
    exchangeRate: 36.24,
    currencySymbol: '₴',
    electricity: 0.115,
    carbonFactor: 206.5,
  },
  {
    code: 'ARE',
    name: <FormattedMessage {...messages.unitedArabEmirates} />,
    exchangeRate: 3.67,
    currencySymbol: 'AED',
    electricity: 0.105,
    carbonFactor: 461.8,
  },
  {
    code: 'GBR',
    name: <FormattedMessage {...messages.unitedKingdom} />,
    exchangeRate: 0.82,
    currencySymbol: '£',
    electricity: 0.395,
    carbonFactor: 257.4,
  },
  {
    code: 'USA',
    name: <FormattedMessage {...messages.unitedStates} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.268,
    carbonFactor: 367.3,
  },
  {
    code: 'URY',
    name: <FormattedMessage {...messages.uruguay} />,
    exchangeRate: 39.96,
    currencySymbol: '$U',
    electricity: 0.145,
    carbonFactor: 114.8,
  },
  {
    code: 'UZB',
    name: <FormattedMessage {...messages.uzbekistan} />,
    exchangeRate: 12237.5,
    currencySymbol: 'лв',
    electricity: 0.049,
    carbonFactor: 505.4,
  },
  {
    code: 'VUT',
    name: <FormattedMessage {...messages.vanuatu} />,
    exchangeRate: 122.66,
    currencySymbol: 'VT',
    electricity: 0.42,
    carbonFactor: 571.4,
  },
  {
    code: 'VAT',
    name: <FormattedMessage {...messages.vaticanCityState} />,
    exchangeRate: 0.95,
    currencySymbol: '€',
    electricity: 0.4,
    carbonFactor: 372,
  },
  {
    code: 'VEN',
    name: <FormattedMessage {...messages.venezuela} />,
    exchangeRate: 35.09,
    currencySymbol: 'Bs',
    electricity: 0.059,
    carbonFactor: 212.5,
  },
  {
    code: 'VNM',
    name: <FormattedMessage {...messages.vietnam} />,
    exchangeRate: 24568,
    currencySymbol: '₫',
    electricity: 0.074,
    carbonFactor: 376.8,
  },
  {
    code: 'VIR',
    name: <FormattedMessage {...messages.virginIslands} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.47,
    carbonFactor: 686,
  },
  {
    code: 'WLF',
    name: <FormattedMessage {...messages.wallisFutunaIslands} />,
    exchangeRate: 112.92,
    currencySymbol: '₣',
    electricity: 0.32,
    carbonFactor: 500,
  },
  {
    code: 'YEM',
    name: <FormattedMessage {...messages.yemen} />,
    exchangeRate: 250.22,
    currencySymbol: '﷼',
    electricity: 0.03,
    carbonFactor: 543.9,
  },
  {
    code: 'ZMB',
    name: <FormattedMessage {...messages.zambia} />,
    exchangeRate: 22.02,
    currencySymbol: 'ZK',
    electricity: 0.039,
    carbonFactor: 84.7,
  },
  {
    code: 'ZWE',
    name: <FormattedMessage {...messages.zimbabwe} />,
    exchangeRate: 322,
    currencySymbol: '$',
    electricity: 0.14,
    carbonFactor: 392.3,
  },
];

export default countries;
